import i18n from "i18next";

import { useTranslation } from "react-i18next";

import why from '../../img/Home/why.webp'

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

import { Link } from "react-router-dom"

function Why () {

    const { t } = useTranslation();

    const controls = useAnimation();
    const [ref, inView] = useInView({ triggerOnce: true }); // `triggerOnce` - чтобы не повторялась

    useEffect(() => {
    if (inView) {
        controls.start({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        transition: { duration: 1, ease: "easeOut" }
        });
    }
    }, [inView, controls]);
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative flex flex-col xl:flex-row justify-between xl:h-[600px]">
                <div className="z-50 flex flex-col absolute xl:relative">
                    <p className="text-[#F26522] text-[50px] md:text-[100px] open-sans leading-[1.4]">{t('home.10')}</p>
                    <p className="text-[#F26522] text-[28px] md:text-[60px] open-sans leading-[1.4]">{t('home.11')}</p>
                    <Link to="/form"><div className="xl:hidden w-[65px] h-[65px] rounded-full border border-[#F6F6F6] mt-[120px] flex items-center justify-center transition-all hover:scale-[0.9]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                            <path d="M14.5 4.20818L14.5 24.7915" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.0694 21.3609L14.5 24.7915L17.9305 21.3609" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div></Link>
                </div>
                <motion.div
                    ref={ref}
                    initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
                    animate={controls}
                    className={`xl:absolute ${i18n.language === 'ar' ? 'xl:pr-[280px] left-0 xl:left-auto mr-auto' : 'xl:pl-[280px] ml-auto right-0 xl:right-auto'} z-0 w-[calc(65%)]`}
                >
                    <img src={why} alt="" className=""/>
                </motion.div>
                <div className="xl:max-w-[450px] mt-[50px] xl:mt-auto">
                    <p className="open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]">{t('home.12')}</p>
                    <p className="open-sans font-[300] text-[#F6F6F6] mt-[15px] text-[14px] xl:text-[16px]">{t('home.13')}</p>
                    <Link to="/form"><div className="w-[90px] h-[90px] hidden rounded-full border border-[#F6F6F6] mt-[45px] xl:flex items-center justify-center transition-all hover:scale-[0.9]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                            <path d="M19 4.75L19 33.25" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.25 28.5L19 33.25L23.75 28.5" stroke="#F6F6F6" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div></Link>
                </div>
            </div>
        </div>
    );
}

export default Why;